module.exports = __webpack_public_path__ + "img/checkmark.ec075755.svg";